import { ApiResponse } from '@ustra/data/src/models/api-model'
import { HttpMethod } from '@ustra/core/src/server/http/const'
import { UtraService } from '@ustra/nuxt/src/services/ustra-service'
import { Menu } from '~/model/menu/menu-model'
import { MyMenu } from '~/model/menu/my-menu-model'

export class MyMenuService extends UtraService {
  async getMyMenu() {
    const result = await this.$ustra.api.call<ApiResponse<MyMenu[]>>({
      url: '/api/cm/menu/selectMyMenuList',
      method: HttpMethod.POST,
      data: {},
    })

    return result.data.body
  }

  async addMyMenu(menu: Menu) {
    const result = await this.$ustra.api.call<ApiResponse>({
      url: '/api/cm/menu/insertMyMenuList',
      method: HttpMethod.POST,
      data: {
        myMenuNm: menu.menuNm,
        menuId: menu.menuId,
        sysGbcd: menu.sysGbcd,
      },
      showLoading: false,
    })

    return result.data.body
  }

  async removeMyMenu(menuId: string) {
    const result = await this.$ustra.api.call<ApiResponse>({
      url: '/api/cm/menu/deleteMyMenuList',
      method: HttpMethod.POST,
      data: {
        menuId,
      },
      showLoading: false,
    })

    return result.data.body
  }
}

export const myMenuService = new MyMenuService()
export default myMenuService
